import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Clock, MapPin, Calendar } from "lucide-react";
import { fmtTime, fmtMonthDay } from "@/lib/format";

export default function MySchedule() {
  const { user } = useAuth();
  const [calls, setCalls] = useState([]);
  useEffect(() => {
    api.get("/calls/mine").then((r) => setCalls(r.data));
  }, []);

  const today = new Date().toISOString().slice(0,10);
  const upcoming = calls.filter((c) => c.rehearsal && c.rehearsal.date >= today);
  const past = calls.filter((c) => c.rehearsal && c.rehearsal.date < today);

  return (
    <div className="space-y-6 animate-fade-up" data-testid="my-schedule-page">
      <header>
        <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">Your calls</div>
        <h1 className="mt-1 font-display text-4xl tracking-tight font-light">My Schedule</h1>
        <p className="mt-1 text-zinc-400 text-sm">Individual call times and rehearsals for {user.name}.</p>
      </header>

      <Section title="Upcoming" items={upcoming} testid="upcoming-calls" />
      <Section title="Past" items={past} testid="past-calls" muted />
    </div>
  );
}

function Section({ title, items, muted, testid }) {
  return (
    <section data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 mb-3">{title}</div>
      <div className="space-y-2">
        {items.length === 0 && <div className="text-sm text-zinc-500 border border-dashed border-white/10 rounded-md p-6 text-center">Nothing here.</div>}
        {items.map((c) => {
          const md = fmtMonthDay(c.rehearsal.date);
          return (
          <div key={c.id} className={`rounded-md border border-white/10 bg-[#121212] p-4 flex items-center gap-4 ${muted ? "opacity-70" : ""}`}>
            <div className="w-16 text-center">
              <div className="text-[10px] uppercase tracking-widest text-zinc-500">{md.month}</div>
              <div className="font-display text-2xl leading-none">{md.day}</div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-white truncate">{c.rehearsal.title}</div>
              <div className="mt-1 flex flex-wrap gap-3 text-xs text-zinc-400">
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> Call {fmtTime(c.call_time)} · ends {fmtTime(c.rehearsal.end_time)}</span>
                <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {c.rehearsal.location}</span>
                {c.role_note && <span className="text-gold">{c.role_note}</span>}
              </div>
            </div>
            <span className="text-[10px] uppercase tracking-widest text-emerald-400 badge-dot">{c.status}</span>
          </div>
          );
        })}
      </div>
    </section>
  );
}
